module.exports = __webpack_public_path__ + "img/up-arrow.4bbc129b.svg";